import { useState, useEffect } from "react";
import './Inbox.css';
import FormInbox from '../FormInbox/FormInbox';
import { collection, deleteDoc, doc, onSnapshot, getDoc, getDocs, query, where } from 'firebase/firestore'; // Importação correta
import { db, auth } from '../../firebase/firebaseConfig'; // Importa o Firestore e Auth
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { useParams } from "react-router-dom"; // Para pegar o token na URL

const Inbox = () => {
    const [formVisible, setFormVisible] = useState(false);
    const [inboxes, setInboxes] = useState([]);
    const [clienteAtual, setClienteAtual] = useState(null);
    const [erro, setErro] = useState(null);
    const { token } = useParams();  // Pega o token da URL
    const userEmail = auth.currentUser?.email;
    const [quemPodeDeletar, setQuemPodeDeletar] = useState('');

    const handleClick = () => {
        setFormVisible(true);
    };

    // Função para buscar o cliente selecionado do sessionStorage
    const getClienteAtual = () => {
        const clienteSalvo = sessionStorage.getItem('clienteSelecionado');
        return clienteSalvo ? JSON.parse(clienteSalvo) : null;
    };

    useEffect(() => {
        // Inicializa a escuta do Firestore para a coleção inbox do usuário autenticado
        const inboxesCollection = collection(db, `usuarios/${userEmail}/inbox`);

        const unsubscribe = onSnapshot(inboxesCollection, (inboxSnapshot) => {
            const inboxesList = inboxSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setInboxes(inboxesList);
        }, (error) => {
            console.error("Erro ao escutar inbox: ", error);
        });

        return () => {
            unsubscribe(); // Cancela a escuta ao desmontar o componente
        };
    }, [userEmail]);

    // Verificar se o token foi passado pela URL
    useEffect(() => {
        if (token) {
            // Aqui você busca os dados do token, como clientId e userEmail
            async function validarToken() {
                try {
                    const docRef = doc(db, 'tokens', token);
                    const docSnap = await getDoc(docRef); // Função getDoc agora está importada

                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        const clienteId = data.clienteId;
                        const emailAdvogado = data.userEmail;

                        // Aqui você precisa garantir que o clienteAtual seja atualizado
                        setClienteAtual({ id: clienteId, email: emailAdvogado });  // Atualize o estado diretamente

                        // Buscar as mensagens do cliente com base no clienteId e userEmail
                        buscarInboxPorCliente(clienteId, emailAdvogado);
                    } else {
                        setErro("Token inválido ou expirado.");
                    }
                } catch (error) {
                    console.error("Erro ao validar token: ", error);
                    setErro("Erro ao validar token.");
                }
            }

            validarToken();
        }
    }, [token]);

    // Buscar inbox baseado no clienteId e userEmail
    const buscarInboxPorCliente = async (clienteId, userEmail) => {
        try {
            // Fazer uma consulta no Firestore filtrando por clienteId
            const inboxesCollection = collection(db, `usuarios/${userEmail}/inbox`);
            const q = query(inboxesCollection, where("clienteId", "==", clienteId));
            const snapshot = await getDocs(q); // Função getDocs agora está importada

            const inboxesList = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setInboxes(inboxesList);
        } catch (error) {
            console.error("Erro ao buscar inbox por cliente:", error);
            setErro("Erro ao buscar inbox.");
        }
    };

    useEffect(() => {
        if (!token) {
            setQuemPodeDeletar('advogado');
      

            const intervalId = setInterval(() => {
                const cliente = getClienteAtual();
                setClienteAtual(cliente);

            }, 1000);  // Verifica a cada 1 segundo se o cliente mudou

            return () => clearInterval(intervalId);  // Limpa o intervalo quando o componente for desmontado
        }
        if (token) {
            setQuemPodeDeletar('cliente');
        
        }

    }, []);


    const handleDeleteInbox = async (id) => {
        if (userEmail) {
            await deleteDoc(doc(db, `usuarios/${userEmail}/inbox`, id));
            setInboxes(inboxes.filter(inbox => inbox.id !== id));
        }
    };

    // Filtra as mensagens pelo ID do cliente atual
    const inboxesFiltradas = inboxes.filter(inbox => {
        if (clienteAtual) {
            return inbox.clienteId === clienteAtual.id;

        }
        return false;
    });

    return (
        <div className='inbox-areacliente'>
            <div className='titulo-inbox'>Inbox</div>
            <div className='conteudo-inbox'>
                <ul className='ul-inbox'>
                    {inboxesFiltradas.length > 0 ? (
                        inboxesFiltradas.map(inbox => (
                            <li className='li-inbox' key={inbox.id}>
                                {inbox.mensagem}
                                {inbox.dono === quemPodeDeletar && (
                                    <button onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteInbox(inbox.id);
                                    }}
                                        className="btn-apaga-inbox">
                                        <FontAwesomeIcon icon={faTrashCan} />
                                    </button>
                                )}
                            </li>
                        ))
                    ) : (
                        <p>Nenhuma mensagem para o cliente selecionado.</p>
                    )}
                </ul>
            </div>
            <div className='container-btn-criar-msg'>
                <button onClick={handleClick} className='btn-criar-msg'> Criar Mensagem</button>
            </div>
            {formVisible && (
                <FormInbox
                    onClose={() => setFormVisible(false)}
                />
            )}
            {erro && <div className="erro">{erro}</div>}
        </div>
    );
};

export default Inbox;
